import * as listVehiclesWaitHappy from './list';
import * as listVehiclesDetailWaitHappy from './detail';
import * as dowloadDetailWaitHappy from './excel';

const Reducers = {
  ...listVehiclesWaitHappy,
  ...listVehiclesDetailWaitHappy,
  ...dowloadDetailWaitHappy,
};

export default Reducers;
